// frontend/shared-ui/src/components/TopBar.jsx
import React from "react";
import Avatar from "./Avatar";
import Badge from "./Badge";
import { Dropdown } from "./Dropdown"; // ← FIXED: named import

export default function TopBar({
  title,
  onToggleSidebar,
  actions = null,
  user,
  userMenu = null,
}) {
  return (
    <header className="fh-topbar">
      {onToggleSidebar && (
        <button
          type="button"
          className="fh-topbar__toggle"
          onClick={onToggleSidebar}
          aria-label="Toggle sidebar"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          >
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
      )}

      {title && <div className="fh-topbar__title">{title}</div>}

      <div className="fh-topbar__spacer" />

      <div className="fh-topbar__actions">
        {actions}

        {user &&
          (userMenu ? (
            <Dropdown
              align="right"
              trigger={
                <div className="fh-topbar__user">
                  <Avatar
                    size="sm"
                    name={user.fullName || user.username}
                    src={user.avatar}
                  />
                  <div className="fh-topbar__user-info">
                    <span className="fh-topbar__user-name">
                      {user.fullName}
                    </span>
                    <span className="fh-topbar__user-role">
                      {user.role?.displayName || user.role?.name}
                    </span>
                  </div>
                  {user.role?.name && (
                    <Badge variant="primary">{user.role.name}</Badge>
                  )}
                </div>
              }
            >
              {userMenu}
            </Dropdown>
          ) : (
            <div className="fh-topbar__user">
              <Avatar
                size="sm"
                name={user.fullName || user.username}
                src={user.avatar}
              />
              <div className="fh-topbar__user-info">
                <span className="fh-topbar__user-name">{user.fullName}</span>
                <span className="fh-topbar__user-role">
                  {user.role?.displayName || user.role?.name}
                </span>
              </div>
            </div>
          ))}
      </div>
    </header>
  );
}
